import React from 'react'
import st from './DeleteCard.module.scss'
import { formatClientDate } from '../utils'
import useLocalization from 'hooks/useLocalization'

const DeleteCard = ({ clickedCards, duplicate, clickedId, setClickedId }) => {
  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      name: 'Name',
      level: 'Level',
      transaction: 'Transaction',
      date_of_creation: 'Date of creation',
      phone_number: 'Phone number',
      responsible: 'Responsible',
      budget: 'Budget',
      city: 'City',
      branch: 'Branch',
      program: 'Program',
      deal_status: 'Deal status',
    },
  })

  const handleCardClick = (cardId) => {
    setClickedId(cardId)
  }

  return (
    <div className={st.infContainer}>
      {clickedCards.map((card) => (
        <div
          key={card.id}
          className={`${st.containerGreenCard} ${card.id === clickedId ? st.container : ''}`}
          onClick={() => handleCardClick(card.id)}
        >
          <div
            className={`${card.id === clickedId ? '' : st.greenCard} ${st.block}`}
          >
            <div className={st.containerInf}>
              <div className={st.information}>
                <div className={st.nameData}>{translate?.name}:</div>
                <div className={st.dataName}>{duplicate.name}</div>
              </div>
              <div className={st.information}>
                <div className={st.name}>{translate?.transaction}:</div>
                <div className={st.data}>#{card.deal_name}</div>
              </div>
              <div className={st.information}>
                <div className={st.name}>{translate?.date_of_creation}:</div>
                <div className={st.data}>
                  {formatClientDate(card.created_at)}
                </div>
              </div>
              <div className={st.information}>
                <div className={st.name}>{translate?.phone_number}:</div>
                <div className={st.data}>{duplicate.phone}</div>
              </div>
            </div>
            <div className={st.block}>
              <div className={st.checkboxInp}>
                <div className={`${st.styleRespons} ${st.widthInf}`}>
                  {translate?.responsible}
                </div>
                <div className={st.styleRespons}>
                  {card?.manager?.full_name}
                </div>
              </div>
              <div className={st.checkboxInp}>
                <div className={`${st.styleRespons} ${st.widthInf}`}>
                  {translate?.budget}
                </div>
                <div className={st.styleRespons}>{card.budget}</div>
              </div>
              <div className={st.checkboxInp}>
                <div className={`${st.styleRespons} ${st.widthInf}`}>
                  {translate?.city}
                </div>
                <div className={st.styleRespons}>{card?.city?.name}</div>
              </div>
              <div className={st.checkboxInp}>
                <div className={`${st.styleRespons} ${st.widthInf}`}>
                  {translate?.branch}
                </div>
                <div className={st.styleRespons}>{card?.branch?.name}</div>
              </div>
              <div className={st.checkboxInp}>
                <div className={`${st.styleRespons} ${st.widthInf}`}>
                  {translate?.program}
                </div>
                <div className={st.styleRespons}>{card?.program?.name}</div>
              </div>
              <div className={st.checkboxInp}>
                <div className={`${st.styleRespons} ${st.widthInf}`}>
                  {translate?.level}
                </div>
                <div className={st.styleRespons}>{card?.level?.name}</div>
              </div>
              <div className={st.checkboxInp}>
                <div className={`${st.styleRespons} ${st.widthInf}`}>
                  {translate?.deal_status}
                </div>
                <div className={st.styleRespons}>{card?.status_deal?.name}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default DeleteCard
